import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import mondaySdk from 'monday-sdk-js';
import React, { useEffect } from 'react';
import * as Yup from 'yup';
import { useUpdateToken } from '../../hooks/useUpdateToken';

const validationSchema = Yup.object({
  apiToken: Yup.string()
    .required('API Token is required')
    .length(48, 'API Token must be exactly 48 characters')
    .test('no-spaces', 'API Token cannot contain spaces', (value) => !/\s/.test(value || '')),
});

const SettingsPage: React.FC = () => {
  const { mutateAsync: updateToken, isPending } = useUpdateToken();

  useEffect(() => {
    const monday = mondaySdk();
    monday.setApiVersion('2024-01');
    // @ts-expect-error -- monday SDK listen is not fully typed
    monday.listen('sessionToken', (res) => {
      localStorage.setItem('token', res.data as unknown as string);
    });
  }, []);

  const formik = useFormik({
    initialValues: {
      apiToken: '',
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      await updateToken(
        { apiToken: values.apiToken },
        {
          onSuccess: () => {
            resetForm();
          },
        },
      );
    },
  });

  return (
    <Box>
      <Stack width="600px" sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Update Clockify API Token
        </Typography>

        <form onSubmit={formik.handleSubmit}>
          <TextField
            fullWidth
            margin="normal"
            id="apiToken"
            name="apiToken"
            label="New Clockify API Token"
            value={formik.values.apiToken}
            onChange={formik.handleChange}
            error={formik.touched.apiToken && Boolean(formik.errors.apiToken)}
            helperText={formik.touched.apiToken && formik.errors.apiToken}
            disabled={isPending}
          />
          <Button
            type="submit"
            size="large"
            variant="contained"
            fullWidth
            sx={{ mt: 3 }}
            disabled={isPending}
          >
            {isPending ? 'Updating...' : 'Update Token'}
          </Button>
        </form>
      </Stack>
    </Box>
  );
};

export default SettingsPage;
